import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

export default function GuidesSection() {
  const { t } = useTranslation();

  const cards = [
    {
      key: 'spread',
      icon: 'ri-table-2',
      link: true,
      image:
        'https://readdy.ai/api/search-image?query=An%20open%20laptop%20displaying%20a%20clean%20organized%20spreadsheet%20with%20product%20thumbnails%20and%20columns%2C%20a%20coffee%20cup%20and%20notebook%20beside%20it%20on%20a%20soft%20cream%20desk%2C%20warm%20natural%20window%20light%2C%20editorial%20workspace%20photography%2C%20high%20detail&width=600&height=600&seq=guide-spread&orientation=squarish',
    },
    {
      key: 'review',
      icon: 'ri-star-line',
      link: false,
      image:
        'https://readdy.ai/api/search-image?query=A%20small%20arrangement%20of%20golden%20five%20star%20rating%20icons%20floating%20above%20a%20folded%20garment%20on%20a%20soft%20sage%20green%20studio%20surface%2C%20gentle%20natural%20light%2C%20minimal%20review%20concept%20product%20photography%2C%20high%20detail&width=600&height=600&seq=guide-review&orientation=squarish',
    },
    {
      key: 'shipping',
      icon: 'ri-truck-line',
      link: false,
      image:
        'https://readdy.ai/api/search-image?query=A%20small%20cardboard%20shipping%20box%20with%20a%20printed%20label%20and%20a%20measuring%20tape%20beside%20it%20on%20a%20warm%20beige%20studio%20surface%2C%20soft%20natural%20light%20and%20gentle%20shadow%2C%20minimal%20logistics%20concept%20photography%2C%20high%20detail&width=600&height=600&seq=guide-shipping&orientation=squarish',
    },
    {
      key: 'coupon',
      icon: 'ri-coupon-3-line',
      link: false,
      image:
        'https://readdy.ai/api/search-image?query=A%20single%20paper%20discount%20coupon%20ticket%20with%20dashed%20perforated%20edges%20and%20a%20percentage%20symbol%20resting%20on%20a%20soft%20blush%20pink%20studio%20surface%2C%20soft%20diffused%20daylight%2C%20minimal%20retail%20concept%20photography%2C%20high%20detail&width=600&height=600&seq=guide-coupon&orientation=squarish',
    },
    {
      key: 'warehouse',
      icon: 'ri-store-2-line',
      link: false,
      image:
        'https://readdy.ai/api/search-image?query=Neat%20rows%20of%20small%20labeled%20cardboard%20boxes%20stacked%20on%20clean%20white%20warehouse%20shelves%20with%20soft%20warm%20lighting%2C%20shallow%20depth%20of%20field%2C%20minimal%20logistics%20and%20storage%20concept%20photography%2C%20high%20detail&width=600&height=600&seq=guide-warehouse&orientation=squarish',
    },
    {
      key: 'legit',
      icon: 'ri-shield-check-line',
      link: false,
      image:
        'https://readdy.ai/api/search-image?query=A%20minimalist%20green%20shield%20icon%20with%20a%20white%20check%20mark%20standing%20on%20a%20soft%20warm%20grey%20studio%20surface%20with%20a%20gentle%20shadow%2C%20soft%20natural%20light%2C%20clean%20trust%20and%20security%20concept%20photography%2C%20high%20detail&width=600&height=600&seq=guide-legit&orientation=squarish',
    },
  ];

  return (
    <section id="guides" className="bg-background-100">
      <div className="mx-auto max-w-7xl px-4 py-16 md:px-6 md:py-24 lg:px-10">
        <div className="mx-auto max-w-2xl text-center">
          <h2 className="font-heading text-2xl font-bold tracking-tight text-foreground-950 md:text-4xl">
            {t('guides.title')}
          </h2>
          <p className="mt-4 text-base text-foreground-600">{t('guides.subtitle')}</p>
        </div>

        <div className="mt-12 grid grid-cols-1 gap-4 sm:grid-cols-2 md:gap-5 lg:grid-cols-3">
          {cards.map((card) => {
            const inner = (
              <>
                <div className="relative h-40 w-full overflow-hidden rounded-t-lg">
                  <img
                    src={card.image}
                    alt={t(`guides.${card.key}.title`)}
                    title={t(`guides.${card.key}.title`)}
                    className="h-full w-full object-cover object-top transition-transform duration-300 group-hover:scale-105"
                  />
                </div>
                <div className="p-6">
                  <h3 className="font-heading text-base font-bold text-foreground-950 md:text-lg">
                    {t(`guides.${card.key}.title`)}
                  </h3>
                  <p className="mt-2 text-sm leading-relaxed text-foreground-600">
                    {t(`guides.${card.key}.desc`)}
                  </p>
                  {card.link && (
                    <span className="mt-4 inline-flex items-center gap-1.5 text-sm font-semibold text-primary-600">
                      {t('cta.readGuide')}
                      <span className="flex h-4 w-4 items-center justify-center">
                        <i className="ri-arrow-right-line text-base leading-none"></i>
                      </span>
                    </span>
                  )}
                </div>
              </>
            );

            const className =
              'group overflow-hidden rounded-lg border border-background-200 bg-background-50 transition-all hover:-translate-y-0.5 hover:border-primary-300 cursor-pointer';

            return card.link ? (
              <Link key={card.key} to="/usfans-spreadsheet" className={className}>
                {inner}
              </Link>
            ) : (
              <div key={card.key} className={className}>
                {inner}
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}